import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ApplicationLoadCard = () => {
  return (
    <div className="app-card">
      <div className="logo-redirect">
        <Skeleton circle={true} width="4rem" height="4rem" />
      </div>
      <h6 className="title w-100">
        {" "}
        <Skeleton width="90%" height="1rem" />
      </h6>
      <p className="w-100">
        {" "}
        <Skeleton width="90%" height="1rem" count={3} />{" "}
      </p>
    </div>
  );
};

export default ApplicationLoadCard;
